import { render, staticRenderFns } from "./ShortType.vue?vue&type=template&id=3efca50d&scoped=true"
import script from "./ShortType.vue?vue&type=script&lang=js"
export * from "./ShortType.vue?vue&type=script&lang=js"
import style0 from "./ShortType.vue?vue&type=style&index=0&id=3efca50d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3efca50d",
  null
  
)

export default component.exports